import { render } from "./UserProfile.vue?vue&type=template&id=5184ce5b&scoped=true"
import script from "./UserProfile.vue?vue&type=script&lang=ts"
export * from "./UserProfile.vue?vue&type=script&lang=ts"

import "./UserProfile.vue?vue&type=style&index=0&id=5184ce5b&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-5184ce5b"

export default script